/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UpdateWorkerEquipmentModelItem } from './update-worker-equipment-model-item';


export interface UpdateWorkerEquipmentModelsRequest { 
    miningProductId: number;
    items: Array<UpdateWorkerEquipmentModelItem>;
}

